<template>
  <div class="incheon">
    <p>
        <img class="incheonSugang" src="@/assets/img/incheon/incheon_seogu.jpg" usemap="#Map">
        <map name="Map">
        <area shape="rect" coords="149,562,788,683" href="https://apply.carrotenglish.net/start?idx=1206" target="_blank">
        </map>
    </p>
  </div>
</template>

<script>
import ImageMap from "image-map";

export default {
  methods: {
    // newPage(path) {
    //   window.open(path, "_blank");
    // },
  },
  mounted(){
    // Mounted
    ImageMap('img[usemap]')
  }
};
</script>

<style lang="scss" scoped>
</style>
<style lang="scss">
.incheon {
  text-align: center;
}
.menu {
  display: none;
}
@media only screen and (max-width: 900px) {
  .incheon {
    width: 100%;
    margin:0 auto;
  }
  .incheonSugang{
    width: 100%;
  }
}
</style>
